var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.book.sinopse)?_c('div',{staticClass:"book"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Capítulos")]),_c('div',{staticClass:"book__content",domProps:{"innerHTML":_vm._s(_vm.book.sinopse)}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }